import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { ComunaService } from 'src/app/services/comuna.service';
import { DocumentoNoTributarioDetService } from 'src/app/services/documento-no-tributario-det.service';
import { EstadoDocumentoService } from 'src/app/services/estado-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { NotaVentaService } from 'src/app/services/nota-venta.service';
import { VendedorService } from 'src/app/services/vendedor.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { OnExit } from 'src/app/shared/guards/can-deactivate.guard';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import Swal from 'sweetalert2';
import { ModalSeleccionarClienteComponent } from '../../shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { AddNotaVentaComponent } from './add-nota-venta/Add-nota-venta/add-nota-venta.component';

@Component({
  selector: 'app-nota-venta',
  templateUrl: './nota-venta.component.html',
  styleUrls: ['./nota-venta.component.scss'],
  providers: [SecurityService],
})
export class NotaVentaComponent implements OnInit, OnExit {
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  @ViewChild(AddNotaVentaComponent, { static: true }) addnotaVenta: AddNotaVentaComponent;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  // Data &  Tmp
  private rutEmpresa: number;
  private sucursalEmpresa: number;

  private headerData = null;
  private currentProcess = null;

  public permiteUnidadNegocio: boolean = false;
  optionsUnidadesDeNegocio: unidad_negocio[] = [];

  // Utils
  private log: any;
  showComponentAdd: boolean = false;

  //selects
  optionsVendedor: Array<any> = [];
  optionsComunas: Array<any> = [];
  optionsEstado: Array<any> = [];

  listanotaVentaAll: Array<any> = null;
  listaNotaVenta: Array<any> = null;
  loading: boolean = false;
  HighlightRow: number;
  estadoItem: boolean = true;
  //TOTALES
  sumMontoNeto: number = 0;
  sumMontoBruto: number = 0;

  paginationContext: PaginationContext = new PaginationContext();
  // Form
  formHeader: FormGroup;

  //variable Nota Venta Especifica
  seleccionNotaVentaEsp: any = null;
  info: any = {};
  mode: string = '';
  notaVentaFacturada: number = 0;
  ValidateNotaVenta: boolean = false;
  ConfirmacionNota: boolean = false;
  loadingNotaVenta: boolean = false; // Flag para prevenir múltiples clicks mientras se carga
  folioSeleccionado: number = null; // Folio de la nota de venta actualmente seleccionada

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private vendedorService: VendedorService,
    private formValidatorsService: FormValidatorsService,
    private toastService: ToastService,
    private datesService: DatesService,
    private comunasService: ComunaService,
    private estadodocService: EstadoDocumentoService,
    private documentoNoTribService: DocumentoNoTributarioDetService,
    private notaventaService: NotaVentaService,
    private rutService: RutService,
    private http: HttpClient
  ) {
    this.log = this.clog.log('MAIN');
  }

  ngOnInit() {
    // this.spinner.show();
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 20;

    this.createForms();
    this.createFormsChangeValues();
    this.loadVendedores();
    this.loadComunas();
    this.loadEstados();
  }
  createFormsChangeValues() {
    this.formHeader
      .get('rutCliente')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente);
      });
  }

  async OnExit() {
    if (this.ValidateNotaVenta == true && this.mode != 'SHOW') {
      //   this.modalConfirmTitle = "Duplicar descuento"
      // this.modalConfirmContent = "¿Desea duplicar el descuento?"
      // const a = this.modalConfirm.show(() => {return true});

      // return a;
      const result = await Swal.fire({
        title: '¿Esta seguro que desea salir de la página?',
        text: 'tus modificaciones se guardarán automaticamente.\n ¿Desea continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.addnotaVenta.CloseNotaVenta();
          this.ConfirmacionNota = result.isConfirmed;
          return this.ConfirmacionNota;
        } else {
          this.ConfirmacionNota = false;
          return this.ConfirmacionNota;
        }
      });

      return result;
    } else {
      this.ValidateNotaVenta = false;
      return true;
    }
  }

  private createForms() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      fechaInicio: [initDate],
      fechaHasta: [currentDate],
      estado: [null, [Validators.required]],
      vendedor: [null, [Validators.required]],
      comuna: [null, [Validators.required]],
      clientes: [null, [Validators.required]],
      nroNotaVenta: [null, [Validators.required]],
      nroFactura: [null, [Validators.required]],
      rutCliente: [null],
    });
  }

  get clientes() {
    return this.formHeader.get('clientes').value;
  }
  set clientes(value: cliente_proveedor[]) {
    this.formHeader.get('clientes').setValue(value);
  }

  private loadVendedores() {
    this.vendedorService.obtenerActivos(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      const { registros } = respuesta;
      this.optionsVendedor = registros.map((vendedor) => ({
        value: vendedor.codigo,
        label: vendedor.nombre,
        ...vendedor,
      }));

      // this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('vendedor'), this.optionsVendedor)
    });
  }

  private loadComunas() {
    // Tipos documentos
    this.comunasService.obtenerDatosComunas(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsComunas = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
    });
  }

  loadEstados() {
    this.estadodocService.obtenerEstadoDocumento(({ mensajes, respuesta }) => {
      const { registros } = respuesta;
      this.optionsEstado = registros.map((estado) => ({ value: estado.codigo, label: estado.nombre, ...estado }));
    });
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show();
  }
  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected();
  }
  onClienteSeleccionado({ data, origien }) {
    this.formHeader.get('rutCliente').setValue(null);
    this.clientes = [data];
  }
  onClienteSeleccionadoMultiple({ data, origien }) {
    this.formHeader.get('rutCliente').setValue(null);
    this.clientes = data;
  }

  ClickedRow(index, nv) {
    // Prevenir múltiples clicks mientras se carga una nota de venta
    if (this.loadingNotaVenta) {
      return;
    }

    this.HighlightRow = index;
    this.notaVentaFacturada = nv.estado_documento_codigo;
    this.estadoItem = false;

    // Limpiar la selección anterior inmediatamente para evitar mostrar datos antiguos
    this.seleccionNotaVentaEsp = null;

    // Marcar que se está cargando una nota de venta
    this.loadingNotaVenta = true;
    const folioActual = nv.folio;

    // Establecer el folio seleccionado ANTES de la llamada asíncrona para prevenir race conditions
    // Esto permite que las respuestas de llamadas anteriores puedan ser detectadas y descartadas
    this.folioSeleccionado = folioActual;

    //CREAR FILTRO NOTA ESPECIFICA.
    const inputParams = {
      entidad: {
        folio: folioActual,
      },
    };

    this.notaventaService.ObtenerDataEspNotaVenta(inputParams, ({ mensajes, respuesta }) => {
      // Verificar que el folio sigue siendo el mismo (evitar race conditions)
      // Si el usuario hizo click en otra fila mientras se cargaba esta, descartar esta respuesta
      if (this.folioSeleccionado !== folioActual) {
        this.loadingNotaVenta = false;
        return; // Se hizo click en otra fila, ignorar esta respuesta
      }

      this.loadingNotaVenta = false;

      if (mensajes && mensajes.length > 0) {
        this.seleccionNotaVentaEsp = null;
        this.folioSeleccionado = null;
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      if (respuesta) {
        const { cabecera, detalle } = respuesta;

        const data = JSON.parse(respuesta.documento);
        data.folio = respuesta.folio;

        // Buscar el objeto original de la lista para obtener folio_factura
        if (this.listaNotaVenta) {
          const nvOriginal = this.listaNotaVenta.find(nv => nv.folio === folioActual);
          if (nvOriginal && nvOriginal.folio_factura) {
            data.folio_factura = nvOriginal.folio_factura;
          }
        }

        // Verificar nuevamente que el folio corresponde antes de establecer la selección
        if (data.folio === folioActual) {
          this.seleccionNotaVentaEsp = data;
          this.folioSeleccionado = folioActual;
        } else {
          this.seleccionNotaVentaEsp = null;
          this.folioSeleccionado = null;
        }
      } else {
        this.seleccionNotaVentaEsp = null;
        this.folioSeleccionado = null;
      }
    });
  }

  //BUSCAR Y MOSTRAR NOTA DE VENTAS

  buscar(pageNumber: number) {
    const { estado, comuna, vendedor } = this.formHeader.value;

    this.paginationContext.CurrentPage = pageNumber;

    // Limpiar la selección de nota de venta al realizar una nueva búsqueda para evitar datos antiguos
    this.seleccionNotaVentaEsp = null;
    this.folioSeleccionado = null;
    this.loadingNotaVenta = false;
    this.HighlightRow = null;
    this.estadoItem = true;

    this.listaNotaVenta = [];
    this.listanotaVentaAll = null;

    const inputParams = {
      estado: estado,
      vendedor: vendedor,
      comuna: comuna,
      clientes: this.clientes ? this.clientes.map((cliente) => cliente.rut) : [],

      filtro: {
        exacto: {
          fecha_desde: this.formHeader.get('fechaInicio').value,
          fecha_hasta: this.formHeader.get('fechaHasta').value,
          rut_empresa: this.rutEmpresa,
          folio: Number(this.formHeader.get('nroNotaVenta').value),
          folio_fact: Number(this.formHeader.get('nroFactura').value),
        },
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: -1,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.documentoNoTribService.obtenerFiltroNotaVenta(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
      this.listanotaVentaAll = this.dedupNotaVentaRegistros(registros || []);
      this.log('lista nota de venta ', JSON.stringify(this.listanotaVentaAll));
      this.listanotaVentaAll.forEach((mov, index) => {
        mov.rutFormato = this.rutService.AgregarDV(mov.direccion_cliente_rut);
      });

      this.paginationContext.RecordsCount = this.listanotaVentaAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = pageNumber;

      const sumallNeto = this.listanotaVentaAll.map((item) => item.total_neto).reduce((prev, curr) => prev + curr, 0);
      const sumallBruto = this.listanotaVentaAll.map((item) => item.total_bruto).reduce((prev, curr) => prev + curr, 0);

      this.sumMontoNeto = sumallNeto;
      this.sumMontoBruto = sumallBruto;

      this.loading = false;
      this.showPage(this.paginationContext.CurrentPage);
    });
  }

  private dedupNotaVentaRegistros(registros: any[]): any[] {
    const byFolio = new Map<number, any>();
    const order: number[] = [];
    const origenesByFolio = new Map<number, Set<string>>();

    const normalizeOrigen = (origen: any): string => {
      return origen === null || typeof origen === 'undefined' || origen === '' ? 'ERP' : String(origen);
    };

    // Al deduplicar, preferir la fila con origen PadSystem para no perder el origen cuando la NV vino de recepción de pedidos
    const score = (row: any): number => {
      const preferPadSystem = row && row.origen === 'PadSystem' ? 2 : 0;
      const hasFactura = row && Array.isArray(row.folio_factura) && row.folio_factura.length > 0 ? 1 : 0;
      return preferPadSystem + hasFactura;
    };

    registros.forEach((r) => {
      const folio = Number(r.folio);
      if (!byFolio.has(folio)) {
        order.push(folio);
        byFolio.set(folio, r);
      } else {
        const existing = byFolio.get(folio);
        if (score(r) > score(existing)) {
          byFolio.set(folio, r);
        }
      }

      if (!origenesByFolio.has(folio)) {
        origenesByFolio.set(folio, new Set<string>());
      }
      origenesByFolio.get(folio).add(normalizeOrigen(r.origen));
    });

    const result = order
      .map((folio) => byFolio.get(folio))
      .filter((r) => !!r);

    // Si existen múltiples orígenes para el mismo folio, mostrar un resumen en una sola fila.
    result.forEach((r) => {
      const folio = Number(r.folio);
      const origenes = origenesByFolio.get(folio);
      if (origenes && origenes.size > 1) {
        r.origen = Array.from(origenes.values())
          .sort((a, b) => a.localeCompare(b))
          .join('/');
      }
    });

    return result;
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listaNotaVenta = _.slice(this.listanotaVentaAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  //AGREGAR NOTA DE VENTA
  showAddVenta() {
    this.addnotaVenta.clearContents();
    this.showComponentAdd = true;
    const show = true;
    this.mode = 'ADD';
    this.addnotaVenta.Show(show, this.mode);
  }

  //CERRAR VEMTANA DE AGREGAR O EDITAR NOTA VENTA
  OnCloseEditAdd(validarNotaVenta) {
    if (validarNotaVenta) {
      this.ValidateNotaVenta = !validarNotaVenta;
    } else {
      this.ValidateNotaVenta = false;
    }
    this.showComponentAdd = false;
    this.HighlightRow = null;
    this.estadoItem = true;
    // Limpiar la selección de nota de venta al cerrar la ventana para evitar mostrar datos antiguos
    this.seleccionNotaVentaEsp = null;
    this.folioSeleccionado = null;
    this.loadingNotaVenta = false;
  }

  //AL GUARDAR UNA NOTA DE VENTA SE REALIZA UN UPDATE DE LA TABLA PRINCIPAL
  onUpdateFiltro() {
    this.ValidateNotaVenta = false;
    // Limpiar completamente la selección de nota de venta para evitar datos antiguos
    this.seleccionNotaVentaEsp = null;
    this.folioSeleccionado = null;
    this.loadingNotaVenta = false;
    this.buscar(1);
    this.HighlightRow = null;
    this.estadoItem = true;
  }

  //MOSTRAR Y EDITAR NOTA DE VENTA SELECCIONADA
  /**
   * Método privado que valida y carga una nota de venta según el modo especificado
   * @param modo - Modo de operación: 'EDIT' para editar, 'SHOW' para mostrar
   * @param mensajeErrorSinSeleccion - Mensaje de error cuando no hay nota de venta seleccionada
   * @returns true si la validación pasó y se cargó la nota, false en caso contrario
   */
  private validarYCargarNotaVenta(modo: 'EDIT' | 'SHOW', mensajeErrorSinSeleccion: string): boolean {
    // Validar que existe una nota de venta seleccionada
    if (!this.seleccionNotaVentaEsp) {
      this.toastService.error(mensajeErrorSinSeleccion);
      return false;
    }

    // Validar que el folio de la selección corresponde al folio seleccionado
    if (this.folioSeleccionado !== null && this.seleccionNotaVentaEsp.folio !== this.folioSeleccionado) {
      this.toastService.error('La nota de venta seleccionada no corresponde. Por favor, seleccione nuevamente.');
      this.seleccionNotaVentaEsp = null;
      this.folioSeleccionado = null;
      return false;
    }

    // Verificar que no se esté cargando otra nota de venta
    if (this.loadingNotaVenta) {
      this.toastService.warning('Espere a que termine de cargar la nota de venta');
      return false;
    }

    this.ValidateNotaVenta = true;
    this.showComponentAdd = true;
    const show = true;
    this.mode = modo;
    this.addnotaVenta.LoadAndShow(this.seleccionNotaVentaEsp, show, this.mode);
    return true;
  }

  OnEditNotaVenta() {
    this.validarYCargarNotaVenta('EDIT', 'Nota de venta generada sin proceso');
  }

  OnShowNotaVenta() {
    this.validarYCargarNotaVenta('SHOW', 'No existe nota de venta');
  }

  //ELIMINAR NOTA DE VENTA
  OnDeleteNotaVenta() {
    const inputParams = {
      entidad: {
        folio: this.seleccionNotaVentaEsp.folio,
      },
    };

    this.modalConfirm.showWithInlineConfig('Eliminar nota de venta', '¿Desea eliminar nota de venta ' + this.seleccionNotaVentaEsp.folio + '?', () => {
      this.notaventaService.eliminarNotaVenta(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.seleccionNotaVentaEsp = null;
          return;
        }

        this.toastService.success('Nota de venta eliminada');
        const page = this.paginationContext.CurrentPage;
        this.buscar(page);
      });
    });
  }

  //LIMPIAR FILTROS
  limpiarfiltros() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside();
    this.formHeader.reset();
    this.formHeader.get('fechaInicio').setValue(initDate);
    this.formHeader.get('fechaHasta').setValue(currentDate);
  }

  // Verificar si hay factura válida (folio_factura es un array)
  tieneFactura(folioFactura: any): boolean {
    if (!folioFactura) {
      return false;
    }
    if (Array.isArray(folioFactura)) {
      return folioFactura.length > 0 && folioFactura[0] != null && folioFactura[0] != '0' && folioFactura[0] != 0;
    }
    return false;
  }

  // Obtener el texto de las facturas para mostrar
  obtenerFacturasTexto(folioFactura: any): string {
    if (!folioFactura || !Array.isArray(folioFactura)) {
      return '';
    }
    return folioFactura.filter(f => f != null && f != '0' && f != 0).join(', ');
  }

  mostrarErrorConversion(error: string): void {
    Swal.fire({
      title: 'Nota de venta no se pudo convertir a factura',
      html: `<p style="margin-top: 8px;"><span style="font-weight: 600;">Razón:</span> ${error}</p>`,
      icon: 'warning',
      confirmButtonText: 'Cerrar',
      width: 520
    });
  }

  /** Si la NV tiene folio de factura asociado se muestra "Facturada", sino el estado que venga del backend */
  obtenerEstadoDisplay(nv: any): string {
    return this.tieneFactura(nv && nv.folio_factura) ? 'Facturada' : (nv.estado_documento_nombre || '');
  }
}
